import React from "react";
import { Info } from "App/Atomics/Input/Select/TagSelect";
import { GenreTagAutoComplete } from "App/Molecules/AutoCompletes/Genre";
import { FilterItem, inputCustomStyle } from "../../formStyle";
import { useAuthGrantStore } from "App/Routes/AuthGrant/Store";
import { IdActions } from "App/Routes/AuthGrant/Store/IdList";

export const GenreExcludeFilter = () => {
  const [{ mode, searchList }, dispatch] = useAuthGrantStore(store => ({
    mode: store.IdList.mode,
    searchList: store.IdList.searchList
  }));
  const excludeGenreList = searchList.Track.excludeGenreList;
  const onSetGenreList = (info: Info[]) => {
    dispatch(IdActions.setExcludeGenreList({ idType: mode, genreList: info }));
  };
  return (
    <FilterItem>
      <div className="item-label">
        <span>장르 제외 리스트</span>
      </div>
      <div className="item-option-wrapper">
        <GenreTagAutoComplete
          style={inputCustomStyle}
          defaultValue={excludeGenreList}
          onBlur={info => info && onSetGenreList(info as Info[])}
        />
      </div>
    </FilterItem>
  );
};
